import { render, staticRenderFns } from "./CreateVoucherType.vue?vue&type=template&id=08464d4c&scoped=true&"
import script from "./CreateVoucherType.vue?vue&type=script&lang=js&"
export * from "./CreateVoucherType.vue?vue&type=script&lang=js&"
import style0 from "./CreateVoucherType.vue?vue&type=style&index=0&id=08464d4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08464d4c",
  null
  
)

component.options.__file = "CreateVoucherType.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!/src/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VContainer,VDialog,VFlex,VLayout,VSpacer,VTextField})
